module.exports = __webpack_public_path__ + "img/KEYlearning-Welcome1.dfb9845d.png";